import { Toaster } from 'react-hot-toast';

const App = () => {
  return (<Toaster position="bottom-center" reverseOrder={false} />);
};

export default App;